import { Grid, makeStyles } from "@material-ui/core";
import React from "react";

interface ImgBlockProps {
  bgImg?: String;
  bgPositionDesktop?: String;
  bgPositionMobile?: String;
}

const useStyles = makeStyles((theme) => ({
  mainWrapperColCenter: (props: ImgBlockProps) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: `${props.bgPositionDesktop}`,
    backgroundSize: "cover",
    height: "75vh",
    backgroundImage: `url(${props.bgImg})`,
    [theme.breakpoints.down("lg")]: {
      height: "75vh",
    },
    [theme.breakpoints.down("md")]: {
      height: "75vh",
    },
    [theme.breakpoints.down("sm")]: {
      height: "75vh",
      backgroundPosition: `${props.bgPositionMobile}`,
    },
    [theme.breakpoints.down("xs")]: {
      height: "50vh",
    },
  }),
}));

export const ImgBlock: React.FC<ImgBlockProps> = (props) => {
  const classes = useStyles(props);

  return <Grid item className={classes.mainWrapperColCenter} xs={12} md={6} />;
};
